// ViewEventRSVPModal.jsx

import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const ViewEventRSVPModal = ({
  open,
  handleClose,
  eventTitle = "Town Hall: Education in District 11",
  rsvps = [],
  isLoading = false,
}) => {
  const totalAttendees = rsvps.reduce(
    (sum, row) => sum + 1 + Number(row.guests || 0),
    0,
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "8px",
          overflow: "hidden",
        },
      }}
    >
      {/* HEADER */}
      <Box
        sx={{
          bgcolor: "#081B44",
          px: 3,
          py: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        {/* LEFT */}
        <Box>
          <Typography
            sx={{
              color: "#D4A017",
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "1px",
              textTransform: "uppercase",
              mb: 0.5,
            }}
          >
            RSVPS
          </Typography>

          <Typography
            sx={{
              color: "#fff",
              fontSize: "18px",
              fontWeight: 700,
            }}
          >
            {eventTitle}
          </Typography>
        </Box>

        {/* RIGHT */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <IconButton
            onClick={handleClose}
            sx={{
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.4)",
              width: 34,
              height: 34,
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      {/* CONTENT */}
      <DialogContent sx={{ p: 3 }}>
        {/* TOP STATS */}
        <Box
          sx={{
            display: "flex",
            gap: 4,
            mb: 3,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              color: "#1B1B1B",
            }}
          >
            <Box component="span" sx={{ fontWeight: 700 }}>
              {rsvps.length}
            </Box>{" "}
            RSVPs
          </Typography>

          <Typography
            sx={{
              fontSize: "14px",
              color: "#1B1B1B",
            }}
          >
            <Box component="span" sx={{ fontWeight: 700 }}>
              {totalAttendees}
            </Box>{" "}
            total attendees
          </Typography>
        </Box>

        {/* TABLE */}
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            border: "1px solid #D9DDE5",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: "#081B44",
                }}
              >
                {[
                  "NAME",
                  "EMAIL",
                  "PHONE",
                  "GUESTS",
                  "SUBMITTED",
                ].map((heading) => (
                  <TableCell
                    key={heading}
                    sx={{
                      color: "#D4A017",
                      fontSize: "11px",
                      fontWeight: 700,
                      borderBottom: "none",
                      py: 2,
                    }}
                  >
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : rsvps.length > 0 ? (
                rsvps.map((row, index) => (
                  <TableRow
                    key={`${row.email}-${index}`}
                    sx={{
                      "& td": {
                        borderBottom:
                          index === rsvps.length - 1
                            ? "none"
                            : "1px solid #E8EAF0",
                      },
                    }}
                  >
                    <TableCell sx={cellStyle}>{row.name || "—"}</TableCell>

                    <TableCell sx={cellStyle}>{row.email || "—"}</TableCell>

                    <TableCell sx={cellStyle}>{row.phone || "—"}</TableCell>

                    <TableCell sx={cellStyle}>{row.guests ?? 0}</TableCell>

                    <TableCell sx={cellStyle}>{row.rsvpDate || "—"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                    No RSVPs found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

const cellStyle = {
  fontSize: "14px",
  color: "#1B1B1B",
  py: 2,
};

export default ViewEventRSVPModal;
